import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { staticClass: "pa-4", attrs: { flat: "", outlined: "" } },
    [
      _vm.value.titulo
        ? _c(
            VCardTitle,
            { staticClass: "subtitle-1 primary--text pa-0 ma-0" },
            [_c("span", [_vm._v(_vm._s(_vm.value.titulo))])]
          )
        : _vm._e(),
      _c(
        VCardText,
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.value.habilitado,
              expression: "value.habilitado",
            },
          ],
          staticClass: "pa-0 ma-0",
        },
        [
          _vm._t("body"),
          _c(
            VRow,
            _vm._l(_vm.value.filhos, function (filho, i) {
              return _c("filtro", { key: i, attrs: { value: filho } })
            }),
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }